import {Component} from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import React from "react";
import Badge from 'react-bootstrap/lib/Badge';
import request from 'request-promise-native';
import LoadingModal from "../modals/LoadingModal";
import ValidatedFormComponent from "../ValidatedFormComponent";
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import YesNoDialog from "../modals/YesNoDialog";
import SuccessDialog from "../modals/SuccessDialog";
import FailedDialog from "../modals/FailedDialog";
import FormDialog from "../modals/FormDialog";
import Alert from "react-bootstrap/lib/Alert";

const GET_PARTNER_LIST = "https://flexa-partner.azurewebsites.net/api/GetPartnerList";
const DELETE_PARTNER = "https://flexa-partner.azurewebsites.net/api/RemovePartner";
const ADD_PARTNER = "https://flexa-partner.azurewebsites.net/api/CreatePartner";
const REGENERATE_PARTNER = "https://flexa-partner.azurewebsites.net/api/RegenerateAPIKey";

const MAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function arraysEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length != b.length) return false;

    for (let i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}

class ListPartnersTab extends Component {

    constructor(props) {
        /*
            Props:
             - access_code
             - logout
        */
        super(props);

        this.state = {
            addPartnerOpen: false,
            addingPartner: false,
            addPartnerSuccess: null,
            addPartnerFailed: null,

            deletePartnerOpen: false,
            deletePartner: null,
            deletingPartner: false,
            deletePartnerSuccess: null,
            deletePartnerFailed: null,

            regeneratePartnerOpen: false,
            regeneratePartner: null,
            regeneratingPartner: false,
            regeneratePartnerSuccess: null,
            regeneratePartnerFailed: null,

            partners: null,
            loading: true,

            searchButton: true,

            //Ordering
            currentOrderParam: null,
            currentOrderDesc: false,

            tableLoading: false,
            pages: 1,
            page: 0
        };

        this.pageCache = null;

        this.currentSearch = null;
    }

    async fetchData(state,instance) {
        console.log("State: ",state);
        console.log("Instance: ",instance);

        const sort = state.sorted[0];
        if(sort.desc!==this.state.currentOrderDesc || sort.id!==this.state.currentOrderParam) {
            this.pageCache = null;
            this.currentOrderDesc = sort.desc;
            this.setState({
                page: 0,
                currentOrderDesc: sort.desc,
                currentOrderParam: sort.id
            });
        }

        this.setState({
            tableLoading: true
        });

        if(this.pageCache==null) {
            const options = {
                method: 'POST',
                uri: GET_PARTNER_LIST,
                body: {
                    access_code: this.props.access_code,

                    orderDescending: sort.desc,
                    orderParam: sort.id,

                    search: this.currentSearch

                    //filterParam: this.state.currentSearch,
                    //filter: state.filter
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            if(response.statusCode!=200) {
                console.log('Logging out!');
                this.props.logout();
                return;
            }

            this.pageCache = [];
            this.pageCache[0] = response.body;

            if(response.body[0]==null || response.body[0].last) {
                this.setState({
                    partners: response.body,
                    tableLoading: false,
                    loading: false,
                    pages: 1
                });
            } else {
                this.setState({
                    partners: response.body,
                    tableLoading: false,
                    loading: false,
                    pages: 2
                });
            }

            console.log("Cards request success");
        } else {
            if(this.pageCache[state.page]!=null) {
                this.setState({
                    partners: this.pageCache[state.page],
                    tableLoading: false,
                    loading: false
                });
            } else {

                let lastSortedBy;

                if(this.pageCache[state.page-1]!=null) {
                    const page = this.pageCache[state.page-1];
                    console.log("Page: "+(state.page-1), page);
                    lastSortedBy = page[9][this.state.currentOrderParam];
                }
                console.log("Last sorted by '"+this.state.currentOrderParam+"': "+lastSortedBy);

                const options = {
                    method: 'POST',
                    uri: GET_PARTNER_LIST,
                    body: {
                        access_code: this.props.access_code,

                        lastSortedBy,

                        orderDescending: this.state.currentOrderDesc,
                        orderParam: this.state.currentOrderParam,

                        search: this.currentSearch

                        //filterParam: this.state.currentSearch,
                        //filter: state.filter
                    },
                    json: true,
                    resolveWithFullResponse: true,
                    simple: false
                };

                const response = await request(options);

                if(response.statusCode!=200) {
                    console.log('Logging out!');
                    this.props.logout();
                    return;
                }

                this.pageCache[state.page] = response.body;

                if(response.body[0]==null || response.body[0].last) {
                    this.setState({
                        partners: response.body,
                        tableLoading: false,
                        loading: false,
                        pages: state.page+1
                    });
                } else {
                    this.setState({
                        partners: response.body,
                        tableLoading: false,
                        loading: false,
                        pages: state.page+2
                    });
                }


                console.log("Cards request success");
            }
        }

    }

    //TODO add functionality
    async regeneratePartner(partner) {
        this.setState({
            regeneratingPartner: true,
            regeneratePartnerSuccess: null,
            regeneratePartnerFailed: null
        });

        const options = {
            method: 'POST',
            uri: REGENERATE_PARTNER,
            body: {
                access_code: this.props.access_code,
                partner: partner.id
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {
            this.setState({
                regeneratePartnerSuccess: response.body.msg,
                regeneratingPartner: false,
            });

            for(let topEntry of this.pageCache) {
                for(let entry of topEntry) {
                    if(entry.id===partner.id) {
                        entry.apiKey = response.body.apiKey;
                    }
                }
            }

            const clonedArr = {... this.state.partners};

            for(let entry of clonedArr) {
                if(entry.id===partner.id) {
                    entry.apiKey = response.body.apiKey;
                    this.setState({
                        partners: clonedArr
                    });
                    return;
                }
            }

            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
        }

        this.setState({
            regeneratePartnerFailed: response.body,
            regeneratingPartner: false,
        });
    }

    //TODO add functionality
    async deletePartner(partner) {

        this.setState({
            deletingPartner: true,
            deletePartnerSuccess: null,
            deletePartnerFailed: null
        });

        const options = {
            method: 'POST',
            uri: DELETE_PARTNER,
            body: {
                access_code: this.props.access_code,
                partner: partner.id
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {
            this.setState({
                deletePartnerSuccess: response.body,
                deletingPartner: false,
            });
            this.resetTable();
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
        }

        this.setState({
            deletePartnerFailed: response.body,
            deletingPartner: false,
        });

    }

    resetTable() {
        this.pageCache = null;
        this.setState({
            page: 0
        },() => {
            this.fetchData.bind(this)({
                sorted: [
                    {
                        desc: this.currentOrderDesc
                    }
                ]
            },null);
        });
    }

    async addPartner(name, mail, description) {

        this.setState({
            addingPartner: true,
            addPartnerSuccess: null,
            addPartnerFailed: null
        });

        const options = {
            method: 'POST',
            uri: ADD_PARTNER,
            body: {
                access_code: this.props.access_code,
                mail,
                name,
                description
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {
            this.setState({
                addPartnerSuccess: response.body,
                addingPartner: false,
            });
            this.resetTable();
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
        }

        this.setState({
            addPartnerFailed: response.body,
            addingPartner: false,
        });

    }

    render() {
        if(!this.props.open) return null;
        return (
            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h3 className="page-title"><i className="mdi mdi-account"></i> Partners</h3>
                            <div className="ml-auto text-right">
                                <button className="btn btn-primary" onClick = {() => this.setState({addPartnerOpen: true})}>
                                    <i className="mdi mdi-plus font-16"></i>Add Partner
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                <YesNoDialog open={this.state.deletePartnerOpen}
                             title="Delete partner"
                             text={(
                                <div>
                                    Do you really want to delete this partner?<br/>
                                    <b>Name:</b> {this.state.deletePartner ? this.state.deletePartner.name : ""}<br/>
                                    <b>E-Mail:</b> {this.state.deletePartner ? this.state.deletePartner.mail : ""}
                                </div>
                             )}
                             onYes={() => {
                                 this.deletePartner.bind(this)(this.state.deletePartner);
                                 this.setState({
                                     deletePartnerOpen: false,
                                     deletePartner: null,
                                     deletingPartner: true
                                 });
                             }}
                             onNo={() => {
                                 this.setState({
                                     deletePartnerOpen: false,
                                     deletePartner: null,
                                 });
                             }}
                            />
                <LoadingModal open={this.state.deletingPartner}
                                title="Deleting partner..."
                />

                <FailedDialog open={!!this.state.deletePartnerFailed}
                              onClose={() => this.setState({deletePartnerFailed:false})}
                              title="Delete failed"
                              text="Partner cannot be removed!"/>
                <SuccessDialog open={!!this.state.deletePartnerSuccess}
                               onClose={() => this.setState({deletePartnerSuccess:false})}
                               title="Delete success"
                               text="Partner has been deleted successfully!"/>

                <YesNoDialog open={this.state.regeneratePartnerOpen}
                             title="Re-generate API key"
                             text={(
                                 <div>
                                     Do you really want to re-generate API key for this partner?<br/>
                                     <b>Name:</b> {this.state.regeneratePartner ? this.state.regeneratePartner.name : ""}<br/>
                                     <b>E-Mail:</b> {this.state.regeneratePartner ? this.state.regeneratePartner.mail : ""}<br/>
                                     <b>API key:</b> {this.state.regeneratePartner ? this.state.regeneratePartner.apiKey : ""}
                                 </div>
                             )}
                             onYes={() => {
                                 this.regeneratePartner.bind(this)(this.state.regeneratePartner);
                                 this.setState({
                                     regeneratePartnerOpen: false,
                                     regeneratePartner: null,
                                     regeneratingPartner: true
                                 });
                             }}
                             onNo={() => {
                                 this.setState({
                                     regeneratePartnerOpen: false,
                                     regeneratePartner: null,
                                 });
                             }}
                />
                <LoadingModal open={this.state.regeneratingPartner}
                              title="Re-generating partner's API key..."
                />

                <FailedDialog open={!!this.state.regeneratePartnerFailed}
                              onClose={() => this.setState({regeneratePartnerFailed:null})}
                              title="Re-generation failed"
                              text={this.state.regeneratePartnerFailed}/>
                <SuccessDialog open={!!this.state.regeneratePartnerSuccess}
                               onClose={() => this.setState({regeneratePartnerSuccess:null})}
                               title="Re-generation success"
                               text={this.state.regeneratePartnerSuccess}/>

                <FormDialog open={this.state.addPartnerOpen}
                            onClose={() => {
                                this.setState({
                                    addPartnerOpen:false,
                                    addPartnerFailed: null,
                                    addPartnerSuccess: null
                                })
                            }}
                            titleText="Add partner"
                            submitText="Add partner"
                            inputs={[
                                {
                                    onValidate: (value) => {
                                        return value==='' ? "Name cannot be empty!" : null;
                                    },
                                    name: "Name",
                                    type: "text",
                                    placeholder: "Enter partner's name"
                                },
                                {
                                    onValidate: (value) => {
                                        return MAIL_REGEX.test(value) ? null : "Not a valid e-mail!";
                                    },
                                    name: "E-Mail",
                                    type: "text",
                                    placeholder: "Enter partner's e-mail"
                                },
                                {
                                    onValidate: (value) => {
                                        return null;
                                    },
                                    name: "Description",
                                    type: "textarea",
                                    placeholder: "Enter partner's description"
                                }
                            ]}
                            onSubmit={(obj) => {
                                const name = obj["Name"];
                                const mail = obj["E-Mail"];
                                const description = obj["Description"];
                                this.addPartner.bind(this)(name,mail,description);
                            }}
                            notification={this.state.addPartnerSuccess ? (<Alert bsStyle="success"><strong>{this.state.addPartnerSuccess}</strong></Alert>) : this.state.addPartnerFailed ? (<Alert bsStyle="danger"><strong>{this.state.addPartnerFailed}</strong></Alert>) : ""}
                            loading={this.state.addingPartner}/>

                <div className="mt-4">
                    <Col sm={4} xs={8}>
                        <ValidatedFormComponent
                            type="text"
                            placeholder="Search"
                            onValidate={input => {
                                return null;
                            }}
                            inputRef={ref => this.searchRef=ref}
                            onChange={input => {
                                if(input==='' && this.currentSearch!=null) {
                                    this.setState({
                                        searchButton: false
                                    });
                                    return;
                                }

                                if(input!==this.currentSearch) {
                                    if(!this.state.searchButton) this.setState({
                                        searchButton: true
                                    })
                                }
                                if(input===this.currentSearch) {
                                    if(this.state.searchButton) this.setState({
                                        searchButton: false
                                    });
                                }
                            }}
                        />
                    </Col>
                    {this.state.searchButton ? (<Button bsStyle="success" onClick={() => {
                        if(this.searchRef.value!=='') {
                            if(this.currentSearch === this.searchRef.value) return;
                            this.setState({
                                searchButton: false
                            });
                            this.currentSearch = this.searchRef.value;
                            this.resetTable();
                        }
                    }}>
                        <i className="fa fa-search"/>
                    </Button>) : (<Button bsStyle="danger" onClick={() => {
                        if(this.currentSearch) {
                            this.currentSearch = null;
                            this.setState({
                                searchButton: true
                            });
                            this.resetTable();
                        }
                    }}>
                        <i className="fa fa-window-close"/>
                    </Button>)}

                </div>
                <div className="container-fluid">
                    <ReactTable
                        loading={this.state.tableLoading}
                        defaultSorted={[
                            {
                                id: "name",
                                desc: false
                            }
                        ]}
                        SubComponent={(row) => {
                            if(row.original.description!=null && row.original.description!=="") {
                                return (
                                    <div className="mx-4 my-4">
                                        <h4>Description:</h4>
                                        <p>{row.original.description}</p>
                                    </div>
                                )
                            }
                            return null;
                        }}
                        data={this.state.partners==null ? [] : this.state.partners}
                        /*getTdProps={(state, rowInfo, column, instance) => {
                            if(rowInfo!=null && column.Header!=='Delete' && column.Header!=="") return {
                                style: {
                                    cursor: 'pointer'
                                },
                                onClick: e => {
                                    console.log("Cell - onClick", rowInfo.original);
                                    this.setState({
                                        addDeviceOpen: true,
                                        editDevice: rowInfo.original
                                    });
                                }
                            };
                            return {};
                        }}*/
                        columns={[
                            {
                                Header: "Name",
                                accessor: "name"
                            },
                            {
                                Header: "E-Mail",
                                accessor: "mail"
                            },
                            {
                                Header: "Claimed",
                                sortable: false,
                                filterable: false,
                                Cell: (row) => {
                                    if(row.original.ttl<0) {
                                        return (
                                            <Badge><i className="fa fa-check"/></Badge>
                                        );
                                    } else {
                                        let str = "";

                                        const seconds = row.original.remaining;

                                        let minutes = seconds/60;

                                        const hours = Math.floor(minutes/60);
                                        minutes = Math.floor(minutes%60);

                                        str+=hours+" hours";

                                        if(minutes!==0) {
                                            str+=" and "+minutes+" minutes";
                                        }

                                        str+=" remaining";

                                        return (
                                            <div>
                                                <Badge><i className="fa fa-times"/></Badge> <Badge>{str}</Badge>
                                            </div>
                                        );
                                    }
                                }
                            },
                            {
                                Header: "API key",
                                sortable: false,
                                filterable: false,
                                Cell: (row) => {
                                    if(row.original.apiKey!=null) {
                                        return (
                                            <div>
                                                <OverlayTrigger placement="top" overlay={(
                                                    <Tooltip id={"tooltipApiKey"+row.original.id}>
                                                        <strong>Generated on {new Date(row.original.apiKeyChanged).toLocaleString()}</strong>
                                                    </Tooltip>
                                                )}>
                                                    <a>
                                                        {row.original.apiKey}
                                                    </a>
                                                </OverlayTrigger> <OverlayTrigger placement="top" overlay={(
                                                    <Tooltip id={"tooltip"+row.original.id}>
                                                        <strong>Re-generate API key!</strong>
                                                    </Tooltip>
                                                )}>
                                                    <a href="#" onClick={() => {
                                                        this.setState({
                                                            regeneratePartnerOpen: true,
                                                            regeneratePartner: row.original
                                                        })
                                                        console.log(row.original);
                                                    }}><i className="fa fa-sync"></i></a>
                                                </OverlayTrigger>
                                            </div>
                                        );
                                    } else {
                                        return "None";
                                    }
                                }
                            },
                            {
                                Header: "Description",
                                width: 88,
                                Expander: (row) => {
                                    if(row.original.description!=null && row.original.description!=='') {
                                        return (
                                            <div>
                                                <Badge>{row.isExpanded ? (<i className="fa fa-arrow-up"/>) : (<i className="fa fa-arrow-down"/>)}</Badge>
                                            </div>
                                        );
                                    } else {
                                        return (<Badge><i className="fa fa-times"/></Badge>);
                                    }
                                },
                                sortable: false,
                                expander: true
                            },
                            {
                                Header: "Delete",
                                maxWidth: 64,
                                width: 64,
                                Cell: row => (
                                    <OverlayTrigger placement="top" overlay={(
                                        <Tooltip id={"tooltipDelete"+row.original.id}>
                                            <strong>Delete partner!</strong>
                                        </Tooltip>
                                    )}>
                                        <a href="javascript:void(0)" onClick={() => {
                                            this.setState({
                                                deletePartnerOpen: true,
                                                deletePartner: row.original
                                            })
                                            console.log(row.original);
                                        }}><i className="fa fa-trash"></i></a>
                                    </OverlayTrigger>
                                ),
                                sortable: false,
                                filterable: false
                            }
                        ]}
                        defaultSorted={[
                            {
                                id: "name",
                                desc: false
                            }
                        ]}
                        manual
                        pageText={""}
                        ofText={""}
                        pages={this.state.pages}
                        page={this.state.page}
                        onPageChange={(pageIndex) => this.setState({
                            page: pageIndex
                        })}
                        onFetchData={this.fetchData.bind(this)}
                        showPageJump={false}
                        showPageSizeOptions={false}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        collapseOnDataChange={false}
                    />
                </div>
            </div>
        );
    }
}

export default ListPartnersTab;